import {Carousel} from "./carousel.component";
import {Slide} from "./slide.component";
import {SearchValue} from "../searchvalue.service";
import {OnInit} from "@angular/core";
import {Component} from "@angular/core";
import {Product} from "../product";
import {ProductService} from "../product.service";
import {AddButton} from "../cartbutton.component";
import {Router} from "@angular/router";
import { PagerService } from "../_services/perger.service"

@Component({
    selector:'search-result',
    providers: [PagerService],
    template:`
    <div class="detail2">
				<!-- <img src="http://suwenyu.github.io/NCCUCY/img/12810398_967697163321645_1895850552_o.jpg" alt=""> -->
				<div class="info_content2">
					<div class="info">
						<div class="searchbar"><br>
							<div class="search">
							<div class="search1">
							   <span>
							   品牌分類
							 
							   <select style="width: 7em;border-radius: .25em;" #brand>					   
							                 <option value="">所有品牌</option>
							                 <option value="Butterfly">BUTTERFLY</option>
							                 <option value="Stiga">STIGA</option>
                               <option value="Nittaku">Nittaku</option>
                               <option value="Xion">XIOM</option>                                                        
                               <option value="Donic">DONIC</option>
                               <option value="Yasaka">Yasaka</option>
                               <option value="Tibhar">TIBHAR</option>
                               <option value="Andro">andro</option>
                               <option value="Dr.Neubauer紐鮑爾">Dr.Neubauer</option>
                               <option value="Mizuno">MIZUNO</option>
                               <option value="Tsp">TSP</option>
                               <option value="Victas">VICTAS</option>
                               <option value="Joola">JOOLA</option>
                               <option value="Adidas">adidas</option>
                               <option value="紅雙喜DHS">紅雙喜DHS</option>
                               <option value="Crack">Crack</option>
                               <option value="台灣神木">STARWOOD</option>
                               <option value="銀河">銀河</option>
                               <option value="others">其它品牌</option> 
							   </select>
							   </span>
                 <span>                      
							   商品分類
							   <select style="width: 7em;border-radius: .25em;" #category>
							    <option value="">所有分類</option>
                                 <option value="blades">刀板</option>
                                 <option value="penhold">直板</option>
                                 <option value="robbers">膠皮</option>
                                 <option value="clothes">服飾</option>
                                 <option value="shoes">鞋&襪</option>
                                 <option value="bags">拍套&裝備袋(包)</option>
                                 <option value="lowblades">成品拍</option>
                                 <option value="balls">球&置球盒</option>
                                 <option value="tables">球桌&周邊，發球機</option>
                                 <option value="glue">膠水&增能劑</option>   
                                 <option value="accessory">配件&保養清潔品</option>                                
                                 <option value="others">其他商品</option>
							   </select></span>  
							   <button (click)="gotoResult(brand.value,category.value)">商品搜尋</button>
							</div> 
                      
						</div>
						</div>
					
					</div>
					<div class="backinfo2"></div>
					
				</div>
				
				<div class="banner">
				
				<div class="row">
                      <div class="col-md-12">
                        <carousel [interval]="NextPhotoInterval" [noWrap]>
                          <slide *ngFor="let slidez of slides; let index=index"
                                 [active]="slidez.active">
                            <img [src]="slidez.image" style="margin:auto;">

                            
                          </slide>
                        </carousel>
                      </div>
                    
                    </div>
				
                </div>
				

			</div>
			<div class="container">
			<div class="search-title">
			<h2>搜尋結果 <span class="pricecol"></span> </h2>
			
			</div>
			
			
			<div class="productSlider2" >
            <!-- items being paged -->
            <div class="result" *ngFor="let p of pagedItems" align="left">   
                    <button type="button" data-toggle="modal" data-target="#myModal" (click)="onSelect(p.name,p.price,p.id,p.imgsrc,p.description,p.category,p.blade_structure,p.blade_special,p.blade_vibrate,p.blade_hitsize,p.blade_thick,p.blade_holdwidth,p.blade_holdsize,p.blade_madein,p.robber_property,p.robber_speed,p.robber_spin,p.robber_control,p.robber_hard,p.robber_madein,p.other_madein,p.brand)"><img src="{{p.imgsrc}}" alt=""></button>
                    <div id="name" align="center">{{p.name}}</div>
                    <div class="commodity_detail" id="plogo">
                        <img src="../../img/logo/{{p.brand}}.jpg" alt="">
                    </div>
                    <div id="price" align="center"><span class="pricecol">＄{{p.price}}</span></div>
                    </div>
            </div>
            <div style="width:100%;text-align:center;">
            <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
            <!--<li [ngClass]="{disabled:pager.currentPage === 1}"><a (click)="setPage(1)">First</a></li>-->
            <li [ngClass]="{disabled:pager.currentPage === 1}"><a (click)="setPage(pager.currentPage - 1)"><</a></li>
            <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}"><a (click)="setPage(page)">{{page}}</a></li>
            <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}"><a (click)="setPage(pager.currentPage + 1)">></a></li>
            <div class="totalpage">
            共{{pager.totalPages}}頁
            </div>
            <!--<li [ngClass]="{disabled:pager.currentPage === pager.totalPages}"><a (click)="setPage(pager.totalPages)">Last</a></li>-->
            </ul>	
            </div>  
					<!-- Modal -->
                    
                    <div id="myModal" class="modal fade" role="dialog" >
                      <div class="modal-dialog">
                    <!-- Modal content-->
                    <h2>{{pname}}</h2>
                    <div class="modal-content">
                    <div class="cool">
                    <button class="productClose" type="button" data-dismiss="modal"><i class="fa fa-times"></i></button>
                    <div class="modal-left">
                    <img class="product_img" src="{{pimg}}" alt="" >
                    </div>
                    <div class="modal-right">
                    <div class="icon" *ngIf="pcategory=='blades' || pcategory=='penhold'"> 
                    <div class="icon1" align="center"><img src="../../img/icon/06.png"><p>底板結構</p><span class="pricecol"><p>{{pblade_structure}}</p></span></div>
                    <div class="icon1" align="center"><img src="../../img/icon/11.png"><p>震動特性</p><span class="pricecol"><p>{{pblade_vibrate}}</p></span></div>
                     
                     &nbsp;<div class="icon1" align="center"><img src="../../img/icon/08.png"><p>&nbsp;反發特性</p><span class="pricecol"><p>{{pblade_special}}</p></span></div>
                    <div class="icon1" align="center"><img src="../../img/icon/09.png"><p>拍柄尺寸</p><span class="pricecol"><p>{{pblade_holdsize}}</p></span></div>
                    <br>  <div class="icon1" align="center"><img src="../../img/icon/10.png"><p>拍柄底寬</p><span class="pricecol"><p>{{pblade_holdwidth}}</p></span></div>
                     
                     <div class="icon1" align="center"><img src="../../img/icon/12.png"><p>板面尺寸</p><span class="pricecol"><p>{{pblade_hitsize}}</p></span></div>
                     <div class="icon1" align="center"><img src="../../img/icon/13.png"><p>板面厚度</p><span class="pricecol"><p>{{pblade_thick}}</p></span></div>
                     <div class="icon1" align="center"><img src="../../img/icon/05.png"><p>出產地</p><span class="pricecol"><p>{{pblade_madein}}</p></span></div>
                
                     </div> 
                     
                     <div class="icon" *ngIf="pcategory=='robbers'">   
                     
                    <div class="icon2" align="center"><img src="../../img/icon/01.png"><p>性質</p><span class="pricecol"><p>{{probber_property}}</p></span></div>
                    <div class="icon2" align="center"><img src="../../img/icon/07.png"><p>速度</p><span class="pricecol"><p>{{probber_speed}}</p></span></div>
                    <div class="icon2" align="center"><img src="../../img/icon/02.png"><p>旋轉</p><span class="pricecol"><p>{{probber_spin}}</p></span></div>
                     
                    <br> <div class="icon2" align="center"><img src="../../img/icon/03.png"><p>控制</p><span class="pricecol"><p>{{probber_control}}</p></span></div>
                     <div class="icon2" align="center"><img src="../../img/icon/04.png"><p>硬度</p><span class="pricecol"><p>{{probber_hard}}</p></span></div>
                     <div class="icon2" align="center"><img src="../../img/icon/05.png"><p>出產地</p><span class="pricecol"><p>{{probber_madein}}</p></span></div>
                     
                     </div>


                     <div class="icon" *ngIf=" pcategory=='lowblades' || pcategory=='glue' || pcategory=='balls' || pcategory=='clothes' || pcategory=='shoes' || pcategory=='accessory' || pcategory=='bags' || pcategory=='tables'  || pcategory=='others' ">   
                     <div class="icon3" align="center"><img src="../../img/icon/05.png"><p>出產地</p><span class="pricecol"><p>{{pothers_madein}}</p></span></div>
                     </div>

                     <div class="description">
                     <p>{{pdescription}}</p>
                     </div>  

                     <div class="button_panel">

                     <button class="price-btn">＄{{pprice}}</button>

                     <select style="width: 4em;border-radius: .25em;height: 1.75em;background-color: #fff;color: #181896;font-size: 20px;" (change)="onChangeSelected($event.target.value)">
                     <option [value]=1 [selected]="pamount==1">1</option>
                     <option [value]=2>2</option>
                     <option [value]=3>3</option>
                     <option [value]=4>4</option>
                     <option [value]=5>5</option>
                     <option [value]=6>6</option>
                     <option [value]=7>7</option>
                     <option [value]=8>8</option>
                     <option [value]=9>9</option>
                     <option [value]=10>10</option>
                     </select>
  
                     <add [pprice]="pprice" [pid]="pid" [pamount]="pamount" [pname]="pname"></add>
                    
                     </div>
                   
                     
           
                     
                     
                     </div>
                     
                     </div>
    
                    </div>
    
                </div>
            </div>
				
            

			
			
			
			

    `,
    inputs:['pprice','pamount','pid','pimg','pdescription','pcategory','pname','pblade_structure','pblade_special','pblade_vibrate','pblade_hitsize','pblade_thick','pblade_holdwidth','pblade_holdsize','pblade_madein','probber_property','probber_speed','probber_spin','probber_control','probber_hard','probber_madein','pothers_madein']

})

export class SearchResultComponent implements OnInit{

    NextPhotoInterval:number = 8000;
    //Looping or not
    noLoopSlides:boolean = true;
    //Photos
    slides:Array<any> = [];

    ss:any;
    total:number;
    errorMessage:string;

    // all products
    products:Product[];
    // pager object
    pager: any = {};
    // paged items
    pagedItems: Product[];

    public pamount:number;
    public pname:string;
    public pprice:number;
    public pid:number;
    public pimg:string;
    public pdescription:string;
    public pcategory:string;
    public pblade_structure:string;
    public pblade_special:string;
    public pblade_vibrate:string;
    public pblade_hitsize:string;
    public pblade_thick:string;
    public pblade_holdwidth:string;
    public pblade_holdsize:string;
    public pblade_madein:string;
    public probber_property:string;
    public probber_speed:string;
    public probber_spin:string;
    public probber_control:string;
    public probber_hard:string;
    public probber_madein:string;
    public pothers_madein:string;
    public pbrand:string;

    constructor(private pagerService: PagerService,private searchvalue:SearchValue,private productservice:ProductService,private router:Router) {
        this.addNewSlide();
    }

    ngOnInit(){
        this.getProducts();
    }

    getProducts(){
        this.searchvalue.getProduct()
            .subscribe(
                products => {
                    //console.log(this.searchvalue.stype);
                  var sortedArray: Product[] = products.sort((obj1, obj2) => {
                    if (+obj1.json_str > +obj2.json_str) {
                      return 1;
                    }

                    if (+obj1.json_str < +obj2.json_str) {
                      return -1;
                    }

                    return 0;
                  });
                  var NeedToSort:Product[]=[];
                  var DontNeedToSort:Product[]=[];
                  for(var i=0;i<sortedArray.length;i++){
                    if(sortedArray[i].json_str!=""){
                      NeedToSort.push(sortedArray[i]);
                      delete sortedArray[i];
                    }
                  }
                  DontNeedToSort =sortedArray.filter(Boolean);
                  //console.log(NeedToSort);
                  //console.log(DontNeedToSort);

                  for(var i=0;i<DontNeedToSort.length;i++){
                    NeedToSort.push(DontNeedToSort[i]);
                  }

                  this.products = NeedToSort.reverse();
                  this.SortData(this.searchvalue.stype);

                    //console.log(this.products);
                    //this.setPage(1);
                },
                error =>  this.errorMessage = <any>error);
    }

    SortData(type){
        //console.log(type);
        if(type=="b"){
            //brand search , sort by category
            var Category_robbers:Product[]=[];
            var Category_blades:Product[]=[];
            var Category_penhold:Product[]=[];
            var Category_lowblades:Product[]=[];
            var Category_glue:Product[]=[];
            var Category_balls:Product[]=[];
            var Category_clothes:Product[]=[];
            var Category_shoes:Product[]=[];
            var Category_accessory:Product[]=[];
            var Category_bags:Product[]=[];
            var Category_tables:Product[]=[];
            var Category_others:Product[]=[];
            for(var i=0;i<this.products.length;i++){
                if(this.products[i].category=="robbers"){
                    Category_robbers.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].category=="blades"){
                    Category_blades.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].category=="penhold"){
                    Category_penhold.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].category=="lowblades"){
                    Category_lowblades.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].category=="glue"){
                    Category_glue.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].category=="balls"){
                    Category_balls.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].category=="clothes"){
                    Category_clothes.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].category=="shoes"){
                    Category_shoes.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].category=="accessory"){
                    Category_accessory.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].category=="bags"){
                    Category_bags.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].category=="tables"){
                    Category_tables.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].category=="others"){
                    Category_others.push(this.products[i]);
                    delete this.products[i];
                }
            }
            var SortedProducts:Product[]=[];
            SortedProducts=Category_blades.reverse().concat(Category_penhold.reverse().concat(Category_robbers.reverse().concat(Category_clothes.reverse().concat(Category_shoes.reverse().concat(Category_bags.reverse().concat(Category_lowblades.reverse().concat(Category_balls.reverse().concat(Category_tables.reverse().concat(Category_glue.reverse().concat(Category_accessory.reverse().concat(Category_others.reverse())))))))))));
            this.products = SortedProducts;

        }else if(type=="c"){
            //category search, sort by brand
            this.products.sort(function(a, b) {
                return parseFloat(a.brand) - parseFloat(b.brand);
            });
            //first
            var Brand_Butterfly:Product[]=[];
            var Brand_Nittaku:Product[]=[];
            var Brand_Stiga:Product[]=[];
            //other
            var Brand_1:Product[]=[];
            var Brand_2:Product[]=[];
            var Brand_3:Product[]=[];
            var Brand_4:Product[]=[];
            var Brand_5:Product[]=[];
            var Brand_6:Product[]=[];
            var Brand_7:Product[]=[];
            var Brand_8:Product[]=[];
            var Brand_9:Product[]=[];
            var Brand_10:Product[]=[];
            var Brand_11:Product[]=[];
            var Brand_12:Product[]=[];
            var Brand_13:Product[]=[];
            var Brand_14:Product[]=[];
            var Brand_15:Product[]=[];
            var Brand_16:Product[]=[];
            var Brand_17:Product[]=[];
            var Brand_18:Product[]=[];
            var Brand_19:Product[]=[];

            for(var i=0;i<this.products.length;i++){
                if(this.products[i].brand=="Butterfly"){
                    Brand_Butterfly.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].brand=="Stiga"){
                    Brand_Nittaku.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].brand=="Nittaku"){
                    Brand_Stiga.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].brand=="Donic"){
                    Brand_1.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].brand=="Yasaka"){
                    Brand_2.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].brand=="Andro"){
                    Brand_3.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].brand=="Tibhar"){
                    Brand_4.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].brand=="Xion"){
                    Brand_5.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].brand=="紅雙喜DHS"){
                    Brand_6.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].brand=="Tsp"){
                    Brand_7.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].brand=="Victas"){
                    Brand_8.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].brand=="Joola"){
                    Brand_9.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].brand=="Dr.Neubauer紐鮑爾"){
                    Brand_10.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].brand=="Adidas"){
                    Brand_11.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].brand=="銀河"){
                    Brand_12.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].brand=="Mizuno"){
                    Brand_14.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].brand=="Crack"){
                    Brand_18.push(this.products[i]);
                    delete this.products[i];
                }else if(this.products[i].brand=="台灣神木"){
                    Brand_19.push(this.products[i]);
                    delete this.products[i];
                }
                else if(this.products[i].brand=="others"){
                  Brand_15.push(this.products[i]);
                  delete this.products[i];
                }
            }


            var FirstBrandsProducts:Product[]=[];

            FirstBrandsProducts = Brand_Butterfly.reverse().concat(Brand_Nittaku.reverse().concat(Brand_Stiga.reverse()));
            var SortedProducts:Product[]=[];
            SortedProducts = FirstBrandsProducts.concat(Brand_5.reverse().concat(Brand_1.reverse().concat(Brand_2.reverse().concat(Brand_4.reverse().concat(Brand_3.reverse().concat(Brand_10.reverse().concat(Brand_14.reverse().concat(Brand_7.reverse().concat(Brand_8.reverse().concat(Brand_9.reverse().concat(Brand_11.reverse().concat(Brand_6.reverse().concat(Brand_18.reverse().concat(Brand_19.reverse().concat(Brand_12.reverse().concat(Brand_15.reverse()))))))))))))))));

            this.products = SortedProducts;

        }else{
          //brand and category search
          //category search, sort by brand
          this.products.sort(function(a, b) {
            return parseFloat(a.brand) - parseFloat(b.brand);
          });
          //first
          var Brand_Butterfly:Product[]=[];
          var Brand_Nittaku:Product[]=[];
          var Brand_Stiga:Product[]=[];
          //other
          var Brand_1:Product[]=[];
          var Brand_2:Product[]=[];
          var Brand_3:Product[]=[];
          var Brand_4:Product[]=[];
          var Brand_5:Product[]=[];
          var Brand_6:Product[]=[];
          var Brand_7:Product[]=[];
          var Brand_8:Product[]=[];
          var Brand_9:Product[]=[];
          var Brand_10:Product[]=[];
          var Brand_11:Product[]=[];
          var Brand_12:Product[]=[];
          var Brand_13:Product[]=[];
          var Brand_14:Product[]=[];
          var Brand_15:Product[]=[];
          var Brand_16:Product[]=[];
          var Brand_17:Product[]=[];
          var Brand_18:Product[]=[];
          var Brand_19:Product[]=[];
          var Brand_20:Product[]=[];
          var Brand_21:Product[]=[];
          var Brand_22:Product[]=[];
          var Brand_23:Product[]=[];
          var Brand_24:Product[]=[];
          var Brand_25:Product[]=[];
          var Brand_26:Product[]=[];
          var Brand_27:Product[]=[];
          var Brand_28:Product[]=[];
          var Brand_29:Product[]=[];
          var Brand_30:Product[]=[];
          var Brand_31:Product[]=[];
          var Brand_32:Product[]=[];
          var Brand_33:Product[]=[];
          var Brand_34:Product[]=[];
          var Brand_35:Product[]=[];
          var Brand_36:Product[]=[];
          var Brand_37:Product[]=[];
          var Brand_38:Product[]=[];
          var Brand_39:Product[]=[];
          var Brand_40:Product[]=[];
          var Brand_41:Product[]=[];
          var Brand_42:Product[]=[];
          var Brand_43:Product[]=[];
          var Brand_44:Product[]=[];
          var Brand_45:Product[]=[];
          var Brand_46:Product[]=[];
          var Brand_47:Product[]=[];
          var Brand_48:Product[]=[];
          var Brand_49:Product[]=[];
          var Brand_50:Product[]=[];
          var Brand_51:Product[]=[];
          var Brand_52:Product[]=[];
          var Brand_53:Product[]=[];
          var Brand_54:Product[]=[];
          var Brand_55:Product[]=[];

          var Category_lowblades:Product[]=[];
          var Category_glue:Product[]=[];
          var Category_balls:Product[]=[];
          var Category_clothes:Product[]=[];
          var Category_shoes:Product[]=[];
          var Category_accessory:Product[]=[];
          var Category_bags:Product[]=[];
          var Category_tables:Product[]=[];
          var Category_others:Product[]=[];

          for(var i=0;i<this.products.length;i++){
            if(this.products[i].brand=="Butterfly" && this.products[i].category=="blades"){
              Brand_Butterfly.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Stiga" && this.products[i].category=="blades"){
              Brand_Nittaku.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Nittaku" && this.products[i].category=="blades"){
              Brand_Stiga.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Donic" && this.products[i].category=="blades"){
              Brand_1.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Yasaka" && this.products[i].category=="blades"){
              Brand_2.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Andro" && this.products[i].category=="blades"){
              Brand_3.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Tibhar" && this.products[i].category=="blades"){
              Brand_4.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Xion" && this.products[i].category=="blades"){
              Brand_5.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="紅雙喜DHS" && this.products[i].category=="blades"){
              Brand_53.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Butterfly" && this.products[i].category=="penhold"){
              Brand_6.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Stiga" && this.products[i].category=="penhold"){
              Brand_7.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Nittaku" && this.products[i].category=="penhold"){
              Brand_8.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Butterfly" && this.products[i].category=="robbers"){
              Brand_9.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Stiga" && this.products[i].category=="robbers"){
              Brand_10.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Nittaku" && this.products[i].category=="robbers"){
              Brand_11.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Donic" && this.products[i].category=="robbers"){
              Brand_12.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Yasaka" && this.products[i].category=="robbers"){
              Brand_13.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Andro" && this.products[i].category=="robbers"){
              Brand_14.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Tibhar" && this.products[i].category=="robbers"){
              Brand_15.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="紅雙喜DHS" && this.products[i].category=="robbers"){
              Brand_16.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Tsp" && this.products[i].category=="robbers"){
              Brand_17.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Butterfly" && this.products[i].category=="clothes"){
              Brand_18.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Stiga" && this.products[i].category=="clothes"){
              Brand_19.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Nittaku" && this.products[i].category=="clothes"){
              Brand_20.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].category=="clothes"){
              Category_clothes.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Butterfly" && this.products[i].category=="shoes"){
              Brand_21.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Stiga" && this.products[i].category=="shoes"){
              Brand_22.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Donic" && this.products[i].category=="shoes") {
              Brand_23.push(this.products[i]);
            } else if(this.products[i].brand=="Butterfly" && this.products[i].category=="bags"){
              Brand_24.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Stiga" && this.products[i].category=="bags"){
              Brand_25.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Nittaku" && this.products[i].category=="bags"){
              Brand_26.push(this.products[i]);
            }else if(this.products[i].brand=="Tibhar" && this.products[i].category=="bags"){
              Brand_27.push(this.products[i]);
            }else if(this.products[i].brand=="Butterfly" && this.products[i].category=="lowblades"){
              Brand_28.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Nittaku" && this.products[i].category=="lowblades"){
              Brand_29.push(this.products[i]);
              delete this.products[i];
            }

            else if(this.products[i].brand=="Nittaku" && this.products[i].category=="lowblades"){
              Category_lowblades.push(this.products[i]);
            }
            else if(this.products[i].brand=="Butterfly" && this.products[i].category=="balls"){
              Brand_30.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Stiga" && this.products[i].category=="balls"){
              Brand_31.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Nittaku" && this.products[i].category=="balls"){
              Brand_32.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="紅雙喜DHS" && this.products[i].category=="balls"){
              Brand_33.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="銀河" && this.products[i].category=="balls"){
              Brand_34.push(this.products[i]);
              delete this.products[i];
            }
            else if(this.products[i].brand=="Butterfly" && this.products[i].category=="tables"){
              Brand_35.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Stiga" && this.products[i].category=="tables"){
              Brand_36.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Nittaku" && this.products[i].category=="tables"){
              Brand_37.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Donic" && this.products[i].category=="tables"){
              Brand_38.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Crack" && this.products[i].category=="tables"){
              Brand_39.push(this.products[i]);
              delete this.products[i];
            }
            else if(this.products[i].brand=="Butterfly" && this.products[i].category=="glue"){
              Brand_40.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Stiga" && this.products[i].category=="glue"){
              Brand_41.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Nittaku" && this.products[i].category=="glue"){
              Brand_42.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="紅雙喜DHS" && this.products[i].category=="glue"){
              Brand_43.push(this.products[i]);
              delete this.products[i];
            }
            else if(this.products[i].brand=="Butterfly" && this.products[i].category=="accessory"){
              Brand_44.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Nittaku" && this.products[i].category=="accessory"){
              Brand_45.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Donic" && this.products[i].category=="accessory"){
              Brand_46.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Yasaka" && this.products[i].category=="accessory"){
              Brand_47.push(this.products[i]);
              delete this.products[i];
            }
            else if(this.products[i].brand=="Xion" && this.products[i].category=="accessory"){
              Brand_48.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Tsp" && this.products[i].category=="accessory"){
              Brand_49.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Mizuno" && this.products[i].category=="blades"){
              Brand_50.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].brand=="Mizuno" && this.products[i].category=="robbers"){
              Brand_53.push(this.products[i]);
              delete this.products[i];
            }
            else if(this.products[i].brand=="Mizuno" && this.products[i].category=="accessory"){
              Brand_54.push(this.products[i]);
              delete this.products[i];
            }
            else if(this.products[i].brand=="銀河" && this.products[i].category=="accessory"){
              Brand_51.push(this.products[i]);
              delete this.products[i];
            }
            else if(this.products[i].brand=="Andro" && this.products[i].category=="accessory"){
              Brand_52.push(this.products[i]);
              delete this.products[i];
            }
            else if(this.products[i].brand=="Xion" && this.products[i].category=="robbers"){
              Brand_55.push(this.products[i]);
              delete this.products[i];
            }
            else if(this.products[i].category=="tables"){
              Category_tables.push(this.products[i]);
              delete this.products[i];
            }
            else if(this.products[i].category=="balls"){
              Category_balls.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].category=="shoes"){
              Category_shoes.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].category=="accessory"){
              Category_accessory.push(this.products[i]);
              delete this.products[i];
            }
            else if(this.products[i].category=="glue"){
              Category_glue.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].category=="bags"){
              Category_bags.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].category=="tables"){
              Category_tables.push(this.products[i]);
              delete this.products[i];
            }else if(this.products[i].category=="others"){
              Category_others.push(this.products[i]);
              delete this.products[i];
            }
          }


          var FirstBrandsProducts:Product[]=[];

          FirstBrandsProducts = Brand_Butterfly.reverse().concat(Brand_Nittaku.reverse().concat(Brand_Stiga.reverse()));
          var SortedProducts:Product[]=[];
          SortedProducts = FirstBrandsProducts.concat(Brand_1.reverse().concat(Brand_2.reverse().concat(Brand_3.reverse().concat(Brand_4.reverse().concat(Brand_5.reverse().concat(Brand_53.reverse().concat(Brand_6.reverse().concat(Brand_7.reverse().concat(Brand_8.reverse().concat(Brand_9.reverse().concat(Brand_10.reverse().concat(Brand_11.reverse().concat(Brand_12.reverse().concat(Brand_13.reverse().concat(Brand_14.reverse().concat(Brand_15.reverse().concat(Brand_16.reverse().concat(Brand_17.reverse().concat(Brand_18.reverse().concat(Brand_19.reverse().concat(Brand_20.reverse().concat(Category_clothes.concat(Brand_21.reverse().concat(Brand_22.reverse().concat(Brand_23.reverse().concat(Category_shoes.concat(Brand_24.reverse().concat(Brand_25.reverse().concat(Brand_26.reverse().concat(Brand_27.reverse().concat(Category_bags.reverse().concat(Brand_28.reverse().concat(Brand_29.reverse().concat(Category_lowblades.reverse().concat(Brand_30.reverse().concat(Brand_31.reverse().concat(Brand_32.reverse().concat(Brand_33.reverse().concat(Brand_34.reverse().concat(Category_balls.reverse().concat(Brand_35.reverse().concat(Brand_36.reverse().concat(Brand_37.reverse().concat(Brand_38.reverse().concat(Brand_39.reverse().concat(Category_tables.reverse().concat(Brand_40.reverse().concat(Brand_41.reverse().concat(Brand_42.reverse().concat(Brand_43.reverse().concat(Category_glue.reverse().concat(Brand_44.reverse().concat(Brand_45.reverse().concat(Brand_46.reverse().concat(Brand_47.reverse().concat(Brand_48.reverse().concat(Brand_49.reverse().concat(Brand_50.reverse().concat(Brand_53.reverse().concat(Brand_54.reverse().concat(Brand_51.reverse().concat(Brand_52.reverse().concat(Brand_55.reverse().concat(Category_accessory.reverse().concat(Category_others.reverse()))))))))))
          )))))))))))))))))))))))))))))))))))))))))))))))))))))));
          this.products = SortedProducts;
        }
      this.setPage(1);
    }
    setPage(page: number) {
                if (page < 1 || page > this.pager.totalPages) {
                    return;
                }

                // get pager object from service
                this.pager = this.pagerService.getPager(this.products.length, page);
         
                // get current page of items
                this.pagedItems = this.products.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }

    private addNewSlide() {
        this.slides.push(
            {image:'../../img/slideshow1.png',text:'BMW 1'},
            {image:'../../img/slideshow2.png',text:'BMW 2'},
            {image:'../../img/slideshow3.png',text:'BMW 3'}

        );
    }
    onChangeSelected(amount:number){
        this.pamount=amount;
    }

    onSelect(name:string,product: number,productid:number,pimg:string,pdescription:string,pcategory,pblade_structure:string,pblade_special:string,pblade_vibrate:string,pblade_hitsize:string,pblade_thick:string,pblade_holdwidth:string,pblade_holdsize:string,pblade_madein:string,probber_property:string,probber_speed:string,probber_spin:string,probber_control:string,probber_hard:string,probber_madein:string,pothers_madein:string,pbrand:string) {
        this.pamount=1;
        this.pname=name;
        this.pprice = product;
        this.pid=productid;
        this.pimg=pimg;
        this.pdescription=pdescription;
        this.pcategory=pcategory;
        this.pblade_structure=pblade_structure;
        this.pblade_special=pblade_special;
        this.pblade_vibrate=pblade_vibrate;
        this.pblade_hitsize=pblade_hitsize;
        this.pblade_thick=pblade_thick;
        this.pblade_holdwidth=pblade_holdwidth;
        this.pblade_holdsize=pblade_holdsize;
        this.pblade_madein=pblade_madein;
        this.probber_property=probber_property;
        this.probber_speed=probber_speed;
        this.probber_spin=probber_spin;
        this.probber_control=probber_control;
        this.probber_hard=probber_hard;
        this.probber_madein=probber_madein;
        this.pothers_madein=pothers_madein;
        this.pbrand=pbrand;
    }

    private removeLastSlide() {
        this.slides.pop();
    }

    countNum(){
        var total=0;
        for(var item of this.products){
            total+=1;
        }
        return total;
    }

    gotoResult(value,value2){
        this.searchvalue.add(value,value2)
        this.router.navigate(['SearchResult2']);
    }
}



// WEBPACK FOOTER //
// ./src/app/Home/searchresult.component.ts